import {Component, OnInit, ViewChild} from '@angular/core';
import {ConfirmationService, ConfirmEventType, MenuItem, MessageService} from 'primeng/api';
import {Router} from '@angular/router';
import {Menu} from 'primeng/menu';
import {Paginator} from 'primeng/paginator';
import {Platform} from '@angular/cdk/platform';
import {BreakpointObserver} from '@angular/cdk/layout';
import {CommonService} from '../@shared/services/common.service';
import {CacheService} from '../@shared/services/cache.service';
import * as FileSaver from 'file-saver';
import {DatePipe} from '@angular/common';
import {BookingService} from '../@shared/new-services/booking.service';

@Component({
    selector: 'app-booking-summary',
    templateUrl: './booking-summary.component.html',
    styleUrls: ['./booking-summary.component.scss']
})
export class BookingSummaryComponent implements OnInit {
    @ViewChild('pagination') pagination: Paginator;
    @ViewChild('menu') menuItem: Menu;
    actionMenu: MenuItem[];
    displaySelectedOrderType: string;
    bookings: any;
    // bookingContent: BookingContentObject[];
    filteredBookings: any;
    isLoading = false;
    displayCustomerRefNo: string;
    fromPort: string;
    toPort: string;
    clearFilter = false;
    displayBookingNumber: any;
    fromDate: any;
    toDate: any;
    selectedBookingForActionMenu: any;
    activeOnly = true;
    bookingFilterObj: any;
    screenSize: any;
    // tslint:disable-next-line:align
    selectedView: any = 0;
    isFileDownloading: boolean;

    constructor(private commonService: CommonService,
                private cacheService: CacheService,
                private messageService: MessageService,
                private router: Router,
                public platform: Platform,
                public breakPointObserver: BreakpointObserver,
                private confirmationService: ConfirmationService,
                private bookingService: BookingService) {

    }

    ngOnInit(): void {
        this.getFilteredBookings();
    }

    handleToggle(booking: any, event: Event) {
        this.selectedBookingForActionMenu = booking;
        this.actionMenu = booking?.actionMenu;
        this.menuItem.toggle(event);
    }

    navigateToBookingInvoices() {
        // this.cacheService.cacheResponse('selected-bookingId', [this.selectedBookingForActionMenu]);
        this.router.navigate(['/', 'invoices'],
            {
                queryParams: {
                    bookingId: this.selectedBookingForActionMenu.bookingId
                }
            }
        );
    }

    paginateFilteredBookings(paginateData: any) {
        this.getFilteredBookings(paginateData?.page, 10, this.bookingFilterObj);
    }

    getFilteredBookings(page = 0, size = 10, filterObj?: any) {
        this.isLoading = true;
        this.bookingService
            .getFilteredBookings(filterObj, page, size)
            .subscribe(
                (x) => {
                    this.bookings = x;
                    this.filteredBookings = x;
                    x?.content?.map(res => {
                        res.blCount = '+' + res.blCount;
                        const particularBooking: any = res as any;
                        const menuItems: MenuItem[] = this.createActionMenuForThisBooking(particularBooking);
                        particularBooking.actionMenu = menuItems;
                    });
                    this.isLoading = false;
                }, (error) => {
                    this.isLoading = false;
                    this.messageService.add({
                        summary: 'Bookings Error !',
                        severity: 'error',
                        detail: error?.message ? error?.message : error,
                        key: 'order-bases-error-message',
                        sticky: true
                    });
                }
            );
    }

    createActionMenuForThisBooking(booking: any): MenuItem[] {
        const menuItems: MenuItem[] = [];
        const invoiceAndDocument: MenuItem = {
            label: 'Invoice & Document',
            visible: true,
            command: () => {
                this.navigateToBookingInvoices();
            },
            disabled: !booking?.showInvoice,
        };

        const track: MenuItem = {
            label: 'Track',
            visible: true,
            command: () => {
                this.onClickNavigateToTrack(this.selectedBookingForActionMenu?.bookingGid);
            },
            disabled: !booking?.showTracking,
        };

        const addSi: MenuItem = {
            label: 'Add SI',
            visible: true,
            command: () => {
                this.navigateToAddSi(this.selectedBookingForActionMenu);
            },
            disabled: !booking?.enableAddSi,
        };

        const enableEditSI: MenuItem = {
            label: 'Edit SI',
            visible: true,
            command: () => {
                this.navigateToEditSi(this.selectedBookingForActionMenu);
            },
            disabled: !booking?.enableEditSi,
        };

        const previewSi: MenuItem = {
            label: 'Preview SI',
            visible: true,
            command: () => {
                this.navigateToPreviewSI(this.selectedBookingForActionMenu);
            },
            disabled: !booking?.enablePreviewSi,
        };

        const bookingDocuments: MenuItem = {
            label: 'Documents',
            visible: true,
            command: () => {
                this.navigateToBookingDocuments(this.selectedBookingForActionMenu);
            },
        };

        menuItems.push(track);
        menuItems.push(addSi);
        menuItems.push(previewSi);
        menuItems.push(enableEditSI);
        menuItems.push(invoiceAndDocument);
        menuItems.push(bookingDocuments);
        return menuItems;
    }

    featureNotAvailable() {
        this.messageService.add({
            summary: 'Feature Message !',
            severity: 'info',
            detail: 'Feature will be available soon',
            key: 'order-bases-error-message',
        });
    }

    onClickNavigateToTrack(bookingId) {
        this.router.navigate(['/', 'tracking-vertical'], {
            queryParams: {
                trackingId: bookingId
            }
        });
    }

    applyFilterToBookings(data?: any) {
        // if (data?.action === 'reset') {
        //     this.clearAllFilter();
        //     return;
        // }
        this.bookingFilterObj = data.bookingFilterValue;
        this.activeOnly = this.bookingFilterObj?.activeOnly;
        this.displayBookingNumber = this.bookingFilterObj?.filterByIdentifier;
        this.displaySelectedOrderType = this.bookingFilterObj?.orderTypes?.map((x) => {
            return x + ' ';
        });
        this.displayCustomerRefNo = this.bookingFilterObj?.customerReferenceNumber;
        this.fromPort = this.bookingFilterObj?.loadPort;
        this.toPort = this.bookingFilterObj?.dischargePort;
        this.fromDate = this.bookingFilterObj?.fromDate;
        this.toDate = this.bookingFilterObj?.toDate;
        this.clearFilter = true;
        // this.getFilteredBookings(0, 10, this.bookingFilterObj);
        this.pagination.changePage(0);
    }

    clearAllFilter() {
        this.displayBookingNumber = null;
        this.displaySelectedOrderType = null;
        this.displayCustomerRefNo = null;
        this.fromPort = null;
        this.toPort = null;
        this.fromDate = null;
        this.toDate = null;
        this.clearFilter = false;
        this.activeOnly = true;
        this.bookingFilterObj = null;
        // this.getFilteredBookings(0, 10);
        this.pagination.changePage(0);
    }

    showShipmentDetails(booking: any) {
        this.router.navigate(['/', 'shipment-details'], {
            queryParams: {
                bookingId: booking.bookingId,
                bookingGid: booking.bookingGid,
                shipmentType: booking.shipmentType,
                movementType: booking.movementType
            }
        });
    }

    applyColorTextBaseOnType(shipmentBookingType: any) {
        switch (shipmentBookingType) {
            case 'AIR':
                return 'AIR';
            case 'LCL':
                return 'LCL';
            case 'FCL':
                return 'p-text-success';
            case 'Transport':
                return 'p-text-warning';
            case 'Service Job':
                return 'service-job ';
            case 'Clearance':
                return 'custom-clearance';
            case 'Custom Clearance':
                return 'custom-clearance';
        }
    }

    getColoredBookingStatus(status: any) {
        switch (status) {
            case 'Arrived':
                return 'tertiary-bgcolor';
            case 'In Progress':
                return 'in-progress';
            case 'Delivered':
                return 'delivered';
            case 'Planned':
                return 'planned';
            case 'Confirmed':
                return 'confirmed';
            case 'Booking Created':
                return 'booking-created';
            case 'Completed':
                return 'planned';
            case 'Customs Cleared':
                return 'in-progress';
            case 'Stuffed':
                return 'tertiary-bgcolor';
            case 'Carted':
                return 'tertiary-bgcolor';
            case 'Departed':
                return 'delivered';
            case 'Sailed':
                return 'planned';
            case 'Document Received':
                return 'confirmed';
            case 'Truck Placed':
                return 'tertiary-bgcolor';
            case 'Truck Dispatched':
                return 'in-progress';
            case 'Initiated':
                return 'planned';
            case 'Cancelled':
                return 'blue-bgcolor';
        }
    }

    navigateToAddSi(booking: any) {
        localStorage.setItem('si-action', 'add');
        this.router.navigate(['/', 'shipping-instructions'], {
            queryParams: {
                bookingId: booking?.bookingGid,
                shipmentType: booking?.shipmentType,
                numberOfContainers: booking?.numberOfContainers ? booking?.numberOfContainers : null,
            },
        });

    }

    navigateToEditSi(booking: any) {
        localStorage.setItem('si-action', 'edit');
        this.router.navigate(['/', 'shipping-instructions'], {
            queryParams: {
                bookingId: booking?.bookingGid,
                shipmentType: booking?.shipmentType,
                numberOfContainers: booking?.numberOfContainers ? booking?.numberOfContainers : null,
            },
        });

    }

    navigateToBookingDocuments(booking: any) {
        this.router.navigate(['/', 'documents-listing'],
            {
                queryParams: {
                    documentType: 'Booking',
                    documentNumber: booking?.bookingGid,
                    documentTypeGid: booking?.bookingGid,
                    bookingId: booking?.bookingId
                }
            }
        );
    }

    handleCardViewActions(data: any) {
        if (data.actionFrom === 'menu') {
            this.handleToggle(data.booking, event);
        } else if (data.actionFrom === 'shipment-details') {
            this.showShipmentDetails(data.booking);
        }
    }

    navigateToPreviewSI(booking: any) {
        this.router
            .navigate(
                ['/', 'preview-si'], {
                    queryParams: {
                        bookingId: booking?.bookingGid,
                        shipmentType: booking?.shipmentType,
                    }
                }
            );
    }

    exportExcel(dataContent: any) {
        const exportedBookings = this.exportedColumnsForFileDownload(dataContent);
        import('xlsx').then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(exportedBookings);
            const workbook = {Sheets: {data: worksheet}, SheetNames: ['data']};
            const excelBuffer: any = xlsx.write(workbook, {bookType: 'xlsx', type: 'array'});
            this.saveAsExcelFile(excelBuffer, 'booking-summary');
        });
    }

    saveAsExcelFile(buffer: any, fileName: string): void {
        const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const EXCEL_EXTENSION = '.xlsx';
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    }

    exportPdf(dataContent: any) {
        const cols = [
            {field: 'shipmentType', header: 'Type'},
            {field: 'bookingId', header: 'Booking Number'},
            {field: 'customerReferenceNumber', header: 'Customer Reference Number'},
            {field: 'transportDocument', header: 'Transport Document'},
            {field: 'bookingDate', header: 'Booking Date'},
            {field: 'origin', header: 'Origin'},
            {field: 'departureDate', header: 'Departure'},
            {field: 'destination', header: 'Destination'},
            {field: 'arrivalDate', header: 'Arrival'},
            {field: 'status', header: 'Status'}
        ];
        const exportedColumns = cols.map(col => (
            {title: col.header, dataKey: col.field}
        ));

        import('jspdf').then(jsPDF => {
            import('jspdf-autotable').then(x => {
                // @ts-ignore
                const doc = new jsPDF.default({
                    orientation: 'landscape'
                });
                doc.text('Booking Summary', 15, 10);
                // @ts-ignore
                doc.autoTable(exportedColumns, dataContent, {
                    theme: 'grid',

                    columnStyles: {
                        0: {
                            columnWidth: 15
                        },
                        1: {
                            columnWidth: 35
                        },
                        2: {
                            columnWidth: 35
                        },
                        3: {
                            columnWidth: 30
                        },
                        4: {
                            columnWidth: 30
                        },
                        5: {
                            columnWidth: 25
                        },
                        6: {
                            columnWidth: 25
                        },
                        7: {
                            columnWidth: 25
                        },
                        8: {
                            columnWidth: 25
                        },
                        9: {
                            columnWidth: 25
                        },
                    },
                    headerStyles: {
                        theme: 'grid',
                        fillColor: '#3f51b5',
                    },
                });
                doc.save('booking-summary.pdf');
            });
        });
    }

    exportedColumnsForFileDownload(dataContent: any) {
        const datePipe = new DatePipe('en-US');
        const exportedBookings = dataContent?.map((booking) => {
            const exportBooking = {
                Type: booking?.shipmentType ? booking?.shipmentType : '-',
                'Booking Number': booking?.bookingId ? booking?.bookingId : '-',
                'Customer Reference Number': booking?.customerReferenceNumber,
                'Transport Document': booking?.transportDocument ? booking?.transportDocument : '-',
                'Booking Date': booking?.bookingDate ? datePipe.transform(booking?.bookingDate, 'dd-MMM-yyyy') : '-',
                Origin: booking?.origin ? booking?.origin : '-',
                Departure: booking?.departureDate ? datePipe.transform(booking?.departureDate, 'dd-MMM-yyyy') : '-',
                Destination: booking?.destination ? booking?.destination : '-',
                Arrival: booking?.arrivalDate ? datePipe.transform(booking?.departureDate, 'dd-MMM-yyyy') : '-',
                Status: booking?.status ? booking?.status : '-'
            };
            return exportBooking;
        });
        return exportedBookings;
    }

    downloadFiles(fileType: string) {
        this.confirmationService.confirm({
            message: 'Select the option to download file.',
            header: 'Download Options',
            icon: 'pi pi-download',
            accept: () => {
                // Download the current page only.
                if (fileType === 'pdf') {
                    this.exportPdf(this.filteredBookings?.content);
                } else if (fileType === 'excel') {
                    this.exportExcel(this.filteredBookings?.content);
                }
            },
            reject: (type) => {
                switch (type) {
                    case ConfirmEventType.REJECT:
                        // Download All Pages
                        this.isFileDownloading = true;
                        this.bookingService?.getFilteredBookings(null, 0, 10000)
                            .subscribe((x) => {
                                this.isFileDownloading = false;
                                if (fileType === 'pdf') {
                                    this.exportPdf(x?.content);
                                } else if (fileType === 'excel') {
                                    this.exportExcel(x?.content);
                                }
                            });
                        break;
                    case ConfirmEventType.CANCEL:
                        // Closed dialog box without any options to download.
                        break;
                }
            }
        });
    }


}
